import * as React from 'react'
import classNames from 'classnames'

import imgSizes from 'ui-component-library/utils/imgSizes'

import type { Image } from 'types'
import type { Props as CTAProps } from '../CallToAction'

import CallToAction from '../CallToAction'
import { InlineImage } from 'content-components/_Primatives/Images'
import style from './style.scss'

export type Props = CTAProps & {
  className?: string
  image: Image
  imageSide?: 'left' | 'right'
  imageSize?: 'small' | 'medium' | 'large'
  isGradient?: boolean
}

function CalloutBox(props: Props) {
  const {
    className,
    image,
    imageSide = 'left',
    imageSize = 'medium',
    isGradient = true,
    ...rest
  } = props
  const sizes = imgSizes(400, 1000, 700)

  return (
    <div
      className={classNames(
        style.wrapper,
        {
          [style.imageRight]: imageSide === 'right',
          [style.ctaLeft]: imageSide === 'left',
        },
        className,
      )}
    >
      <>
        <InlineImage
          className={classNames(style.image, style[imageSize])}
          gradient={isGradient}
          image={image}
          sizes={sizes}
        />
        <CallToAction className={style.cta} {...rest} />
      </>
    </div>
  )
}

export default CalloutBox
